import script from "./AdsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdsList.vue?vue&type=script&setup=true&lang=ts"

import "./AdsList.vue?vue&type=style&index=0&id=1ac75312&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac75312"]])

export default __exports__